import { createFileRoute } from "@tanstack/react-router"

import { BrandsListPage } from "~/components/Brands/BrandsListPage"
import AppLayout from "~/layouts/AppLayout"

function BrandsPage() {
  return (
    // Full-height split: the grid and the preview rail each scroll internally (same shell as
    // `/asset-library`), so the rail reads as its own panel beside the list and header.
    <div className="flex min-h-0 flex-1 overflow-hidden">
      <BrandsListPage />
    </div>
  )
}

function BrandsPageWrapper() {
  return (
    // fixedViewport locks <main> to the viewport so the columns can own their scrolling.
    <AppLayout fixedViewport>
      <BrandsPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/brands")({
  component: BrandsPageWrapper,
})
